// L'ALONE DELLA SELEZIONE: se c'è e di che colore. È una preferenza di chi guarda, non un dato del
// prodotto — non entra nella scena e non la segna da salvare. Sta col tema e gli attracchi, nel
// documento delle preferenze sul server (`useWorkspacePreferences`, scope `scene-editor`).
//
// SEGUE SOLO L'INTERRUTTORE, NON LO STRUMENTO. Nei due editor di prima era così: si sceglie una
// mesh per muoverla, e mentre la si muove si deve vedere quale è. Legarlo a «Select» voleva dire
// perderlo proprio con Move, Rotate e Scale in mano.
export type SelectionHighlight = { enabled: boolean; color: string };

/**
 * Porta la preferenza sul motore.
 *
 * RIEVIDENZIA OGNI MESH SCELTA, figli compresi. Il clic sceglie la mesh colpita coi suoi figli — si
 * muovono con lei — ma `showHideHighlight(true)` da solo riaccende soltanto la radice. E riaggiungere
 * una mesh già evidenziata le cambia il colore: è così che il colore nuovo si vede subito.
 *
 * Lo stesso colore vale per il passaggio del mouse, come nell'interface editor, che ne ha uno solo.
 */
export const applySelectionHighlight = (sceneEditor: any, { enabled, color }: SelectionHighlight) => {
    if (!sceneEditor) return;

    sceneEditor.highlightColor = color;
    sceneEditor.highlightOverColor = color;
    sceneEditor.showHideHighlight?.(enabled);
    if (!enabled) return;

    sceneEditor.scene?.meshes?.forEach((mesh: any) => {
        if (sceneEditor.isMeshSelected?.(mesh)) sceneEditor.highlightMesh?.(mesh, true);
    });
};
